import Products from '../interfaces/Product';

export const INITIAL_VALUES: Products = {
  DEPOSITO: '',
  DESCMERCA: '',
  EAN: '',
  GRP_MERCADORIA: '',
  GRUPO: '',
  LOJA: [],
  MERCADORIA: '',
  SECAO: '',
  SUBGRUPO: '',
  USUARIO: ''
}
